import { useState, useRef } from 'react'
import { styled } from '@mui/material'
import Badge from '@mui/material/Badge'
import Button from '@mui/material/Button'
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined'
import { useNotifications } from '@/pages/NotificationCenter/hooks/useNotifications'
import NotificationDropdownPanel from './NotificationDropdownPanel'

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
  padding: '0.5rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: '50px',
  marginRight: '9px',
  '&:hover, &:focus, &:active': {
    backgroundColor: 'transparent',
  },
}))

const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    fontFamily: 'inherit',
    fontSize: '.875rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2px 6px',
  },
  '& svg': {
    fontSize: '24px',
  },
}))

interface NotificationBellProps {
  /**
   * Phones, beside Ask Attorney Share's circle: no extra width around the
   * icon.
   */
  dense?: boolean
}

const NotificationBell = ({ dense = false }: NotificationBellProps) => {
  const [open, setOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const { unreadCount } = useNotifications()

  const handleClick = () => {
    setOpen(!open)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <StyledButton
        ref={buttonRef}
        onClick={handleClick}
        data-testid="notification-bell-button"
        sx={dense ? { minWidth: { xs: 40, sm: 50 } } : undefined}
      >
        <StyledBadge
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          variant="rounded"
          badgeContent={unreadCount}
          sx={{
            color: 'text.secondary',
          }}
        >
          <NotificationsOutlinedIcon
            sx={{
              color: 'text.secondary',
            }}
          />
        </StyledBadge>
      </StyledButton>

      <NotificationDropdownPanel
        open={open}
        anchorEl={buttonRef.current}
        onClose={handleClose}
      />
    </>
  )
}

export default NotificationBell
